import { TableGridColumn } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { useMemo } from "react";
import { DomainRecordCopyCell } from "../../DomainRecordCopyCell";
import { DomainRecordsTableRowData } from "../types";

export const useDomainRecordsTableColumns = () => {
  const { t } = useTranslations();

  return useMemo<TableGridColumn<DomainRecordsTableRowData>[]>(
    () => [
      {
        id: "type",
        title: t({
          id: "client-support-page.type",
          defaultMessage: "Type",
        }),
        grow: true,
        className: "min-w-0 overflow-hidden",
        content: ({ type }) => <DomainRecordCopyCell value={type} />,
      },
      {
        id: "name",
        title: t({
          id: "client-support-page.name",
          defaultMessage: "Name",
        }),
        grow: true,
        className: "min-w-0 overflow-hidden",
        content: ({ name }) => <DomainRecordCopyCell value={name} />,
      },
      {
        id: "value",
        title: t({
          id: "client-support-page.value",
          defaultMessage: "Value",
        }),
        grow: true,
        className: "min-w-0 overflow-hidden",
        content: ({ value }) => <DomainRecordCopyCell value={value} />,
      },
    ],
    [t]
  );
};
